export default {
  categories: []
}
